import { ListProvider } from "./list-provider";
import { Contact } from "../../../../business-objects/contact/contact.model";
import { ContactStoreFacade } from "../../../../business-objects/contact/contact.store-facade";
import { Observable } from "rxjs/Observable";
import { ListPickerControlModalItemModel } from "../list-picker-control-modal-item.model";

export class ContactListProvider extends ListProvider<Contact> {

    getFacade(): ContactStoreFacade {
        return this.appFacade.objects.contact.store;
    }

    getPrimaryField(item: Contact): string {
        return item && item.name;
    }

    getSecondaryField(item: Contact): string {
        return item && item.email;
    }

    getList(contactType: string): Observable<Array<ListPickerControlModalItemModel>> {
        return this.getFacade()
            .getAll()
            .map(items => items.filter(item => item.contactType === contactType))
            .map(items => items.map(item => new ListPickerControlModalItemModel(item.id, this.getPrimaryField(item))));
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/list-picker/form/list-providers/contact-list-provider.ts